"use client";

/** 入力欄。ラベルと補足を添える */
export default function TextField({
  id,
  label,
  type = "text",
  value,
  onChange,
  note,
  autoComplete,
  disabled,
}: {
  id: string;
  label: string;
  type?: "text" | "password";
  value: string;
  onChange: (value: string) => void;
  note?: string;
  autoComplete?: string;
  disabled?: boolean;
}) {
  return (
    <div className="field">
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className="field-input"
        type={type}
        value={value}
        autoComplete={autoComplete}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      />
      {note ? <p className="field-note">{note}</p> : null}
    </div>
  );
}
